var formInputSkinData = ['light', 'dark'];
export default formInputSkinData;